import getEnvironDomain from "../utils/getEnvironDomain";

import api from "./images/s_api.svg";
import automation from "./images/s_automation.svg";
import gps from "./images/s_gps.svg";
import docs from "./images/s_docs.svg";
import orders from "./images/s_orders.svg";
import boards from "./images/s_boards.svg";
import tenders from "./images/s_tenders.svg";
import auctions from "./images/s_auctions.svg";
import index from "./images/s_index.svg";
import middlePrice from "./images/s_middle-price.svg";
import unlimitedCheck from "./images/s_unlimited-check.svg";
import check from "./images/s_check.svg";
import trafficLight from "./images/s_traffic-light.svg";
import messenger from "./images/s_messenger.svg";
import forums from "./images/s_forums.svg";
import realTruck from "./images/s_real-truck.svg";
import distanceCalculator from "./images/s_distance-calculator.svg";
import chains from "./images/s_chains.svg";
import academy from "./images/s_academy.svg";
import loans from "./images/s_loans.svg";
import news from "./images/s_news.svg";
import partnership from "./images/s_partnership.svg";
import rating from "./images/s_rating.svg";
import insurance from "./images/s_insurance.svg";
import truckmarket from "./images/s_truckmarket.svg";
import timeSlots from "./images/s_time-slots.svg";
import partnersOffers from "./images/s_partners-offers.svg";
import catalogs from "./images/s_catalogs.svg";
import tickets from "./images/s_tickets.svg";
import profitableDestination from "./images/s_profitable-destinations.svg";
import guaranteePayment from "./images/s_guarantee-payment.svg";
import courier from "./images/s_courier.svg";
import cargoMap from "./images/s_cargo-map.svg";

import strings from "../locales/strings";

const baseUrl = getEnvironDomain();

const allServicesLinks = {
  api: {
    iconSource: api,
    label: strings.apiLink,
    description: strings.apiLinkDescription,
    href: `https://${baseUrl}/landings/api-ati?utm_source=header&utm_campaign=new_header`,
    code: "SERVICE_API",
  },
  automation: {
    iconSource: automation,
    label: strings.automationLink,
    description: "",
    href: `https://${baseUrl}/landings/integration/?utm_source=header&utm_campaign=new_header`,
    code: "SERVICE_AUTOMATION",
  },
  gps: {
    iconSource: gps,
    label: strings.gpsLink,
    description: strings.gpsDescription,
    href: `https://${baseUrl}/landings/ati-driver?utm_source=header&utm_campaign=new_header`,
    code: "SERVICE_GPS",
  },
  docs: {
    iconSource: docs,
    label: strings.docsLink,
    description: strings.docsDescription,
    href: `https://d.${baseUrl}?utm_source=header`,
    anonimHref: `https://${baseUrl}/landings/d-welcome?utm_source=header&utm_campaign=new_header`,
    code: "SERVICE_DOCS",
  },
  orders: {
    iconSource: orders,
    label: strings.ordersLink,
    description: strings.ordersDescription,
    href: `https://${baseUrl}/landings/udeal/?utm_source=header&utm_campaign=new_header`,
    code: "SERVICE_ORDERS",
  },
  boards: {
    iconSource: boards,
    label: strings.boardsLink,
    description: strings.boardsDescription,
    href: `https://${baseUrl}/boards/public`,
    anonimHref: `https://${baseUrl}/landings/boards?utm_source=header&utm_campaign=new_header`,
    code: "SERVICE_BOARDS",
  },
  tenders: {
    iconSource: tenders,
    label: strings.tendersLink,
    description: strings.tendersDescription,
    href: `https://${baseUrl}/tenders?utm_source=header&utm_campaign=new_header`,
    code: "SERVICE_TENDERS",
  },
  auction: {
    iconSource: auctions,
    label: strings.auctionLink,
    description: strings.auctionDescription,
    href: `https://${baseUrl}/landings/auctions?utm_source=header&utm_campaign=new_header`,
    code: "SERVICE_AUCTION",
  },
  "profitable-destinations": {
    iconSource: profitableDestination,
    label: strings.profitableDestinationsLink,
    description: strings.profitableDestinationsDescription,
    href: `https://${baseUrl}/analytics/profit-directions?utm_source=header&utm_campaign=new_header&utm_content=ProfitDirections_header`,
    code: "SERVICE_PROFITABLE_DESTINATIONS",
  },
  index: {
    iconSource: index,
    label: strings.indexLink,
    description: strings.indexDescription,
    href: `https://${baseUrl}/analytics/index?utm_source=header&utm_campaign=new_header`,
    code: "SERVICE_INDEX",
  },
  "middle-price": {
    iconSource: middlePrice,
    label: strings.middlePriceLink,
    description: strings.middlePriceDescription,
    href: `https://${baseUrl}/analytics/price?utm_source=header&utm_campaign=new_header`,
    code: "SERVICE_MIDDLE_PRICE",
  },
  "unlimited-check": {
    iconSource: unlimitedCheck,
    label: strings.unlimitedCheckLink,
    description: strings.unlimitedCheckDescription,
    href: `https://help.${baseUrl}/reputation-checks?utm_source=header&utm_campaign=new_header`,
    code: "SERVICE_UNLIMITED_CHECK",
  },
  "guarantee-payment": {
    iconSource: guaranteePayment,
    label: strings.guaranteePaymentLink,
    description: strings.guaranteePaymentDescription,
    href: `https://${baseUrl}/landings/payment-guarantee?utm_source=header&utm_campaign=new_header`,
    code: "SERVICE_GUARANTEE_PAYMENT",
  },
  check: {
    iconSource: check,
    label: strings.checkLink,
    shortLabel: strings.checkShortLink,
    description: strings.checkDescription,
    href: `https://${baseUrl}/verification?utm_source=header&utm_campaign=new_header_allservices`,
    anonimHref: `https://${baseUrl}/landings/verification?utm_source=header&utm_campaign=new_header_allservices`,
    code: "SERVICE_CHECK",
  },
  "traffic-light": {
    iconSource: trafficLight,
    label: strings.trafficLightLink,
    description: strings.trafficLightDescription,
    href: `https://${baseUrl}/trafficlight?utm_source=header&utm_campaign=new_header`,
    code: "SERVICE_TRAFFIC_LIGHT",
  },
  messenger: {
    iconSource: messenger,
    label: strings.messengerLink,
    description: strings.messengerDescription,
    href: `https://chat.${baseUrl}/?utm_source=header&utm_campaign=new_header#latest`,
    code: "SERVICE_MESSENGER",
  },
  forums: {
    iconSource: forums,
    label: strings.forumsLink,
    description: strings.forumsDescription,
    href: `https://forums.${baseUrl}/forum?utm_source=header&utm_campaign=new_header`,
    code: "SERVICE_FORUMS",
  },
  "real-truck": {
    iconSource: realTruck,
    label: strings.realTruckLink,
    description: strings.realTruckDescription,
    href: `https://${baseUrl}/active-truckers?utm_source=header&utm_campaign=new_header`,
    code: "SERVICE_REAL_TRUCK",
  },
  "distance-calculator": {
    iconSource: distanceCalculator,
    label: strings.distanceCalculatorLink,
    description: strings.distanceCalculatorDescription,
    href: `https://trace.${baseUrl}?utm_source=header&utm_campaign=new_header`,
    code: "SERVICE_DISTANCE_CALCULATOR",
  },
  chains: {
    iconSource: chains,
    label: strings.chainsLink,
    description: strings.chainsDescription,
    href: `https://loads.${baseUrl}/chains?utm_source=header&utm_campaign=new_header`,
    code: "SERVICE_CHAINS",
  },
  "time-slots": {
    iconSource: timeSlots,
    label: strings.timeSlots,
    description: strings.timeSlotsDescription,
    href: `https://${baseUrl}/timeslots?utm_source=header&utm_campaign=new_header`,
    code: "SERVICE_TIME_SLOTS",
  },
  academy: {
    iconSource: academy,
    label: strings.academyLink,
    description: strings.academyDescription,
    href: `https://academy.${baseUrl}?utm_source=header&utm_campaign=new_header`,
    code: "SERVICE_ACADEMY",
  },
  loans: {
    iconSource: loans,
    label: strings.loansLink,
    description: strings.loansDescription,
    href: `https://${baseUrl}/landings/loans?utm_source=header&utm_campaign=new_header`,
    code: "SERVICE_LOANS",
  },
  news: {
    iconSource: news,
    label: strings.newsLink,
    description: strings.newsDescription,
    href: `https://news.${baseUrl}/index?utm_source=header&utm_campaign=new_header`,
    code: "SERVICE_NEWS",
  },
  partnership: {
    iconSource: partnership,
    label: strings.partnershipLink,
    description: strings.partnershipDescription,
    href: `https://${baseUrl}/referral-program?utm_source=header&utm_campaign=new_header`,
    code: "SERVICE_PARTNERSHIP",
  },
  rating: {
    iconSource: rating,
    label: strings.ratingLink,
    description: strings.ratingDescription,
    href: `https://${baseUrl}/rating?utm_source=header&utm_campaign=new_header`,
    code: "SERVICE_RATING",
  },
  insurance: {
    iconSource: insurance,
    label: strings.insuranceLink,
    description: strings.insuranceDescription,
    href: `https://${baseUrl}/landings/insurances?utm_source=header&utm_campaign=new_header`,
    code: "SERVICE_INSURANCE",
  },
  truckmarket: {
    iconSource: truckmarket,
    label: strings.truckmarketLink,
    description: strings.truckmarketDescription,
    href: `https://tm.${baseUrl}/trucks?utm_source=header&utm_campaign=new_header`,
    code: "SERVICE_TRUCKMARKET",
  },
  "partners-offers": {
    iconSource: partnersOffers,
    label: strings.partnersOffers,
    description: null,
    href: `https://${baseUrl}/partners/?utm_source=header&utm_campaign=new_header`,
    code: "SERVICE_PARTNERS_OFFERS",
  },
  catalogs: {
    iconSource: catalogs,
    label: strings.catalogsLink,
    description: null,
    href: `https://${baseUrl}/catalogs/transport?utm_source=header&utm_campaign=new_header`,
    code: "SERVICE_CATALOGS",
  },
  tickets: {
    iconSource: tickets,
    label: strings.ticketsLink,
    description: null,
    href: `https://${baseUrl}/tickets/?utm_source=header&utm_campaign=new_header`,
    code: "SERVICE_TICKETS",
  },
  courier: {
    iconSource: courier,
    label: strings.courierLink,
    description: null,
    href: `https://${baseUrl}/shipping/?utm_source=header&utm_campaign=new_header`,
    code: "SERVICE_COURIER",
  },
  "cargo-map": {
    iconSource: cargoMap,
    label: strings.cargoMapLink,
    description: null,
    href: `https://${baseUrl}/analytics/cargo-map/?utm_source=header&utm_campaign=new_header`,
    code: "SERVICE_CARGO_MAP",
  },
};

export default allServicesLinks;
